var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "list" },
    [
      _c("app-human-filter-list-edit-node", {
        attrs: {
          "main-node": "",
          node: _vm.mainNode,
          model: _vm.model,
          browse: _vm.browse,
          "something-is-being-dragged": _vm.draggedElement != null,
        },
        on: {
          edit: function ($event) {
            return _vm.onEditNode($event)
          },
          "drag-start": _vm.onDragStart,
          "drag-stop": function ($event) {
            return _vm.onDragStop()
          },
          "drag-drop": _vm.onDrop,
          "emit-changes": function ($event) {
            return _vm.emitChanges()
          },
        },
      }),
      _vm.mainNode.children.length == 0
        ? _c("div", { staticClass: "no-filter" }, [
            _vm._v(" " + _vm._s(_vm.$ct("no-filters")) + " "),
          ])
        : _vm._e(),
      _c(
        "div",
        { staticClass: "actions" },
        [
          _c("w-spacer"),
          _c(
            "w-button",
            {
              staticClass: "cancel mr",
              attrs: { icon: "object-group" },
              on: {
                click: function ($event) {
                  return _vm.addGroup()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("add-filter-group")))]
          ),
          _c(
            "w-button",
            {
              attrs: { icon: "plus" },
              on: {
                click: function ($event) {
                  return _vm.addFilter()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("add-filter")))]
          ),
        ],
        1
      ),
      _c(
        "w-modal",
        { attrs: { value: _vm.filterModal } },
        [
          _vm.toEditFilter
            ? _c("app-edit-filter", {
                attrs: {
                  filter: _vm.toEditFilter,
                  edit: _vm.toEditNode != null,
                  browse: _vm.browse,
                  model: _vm.model,
                  "remove-is-or-option": "",
                },
                on: {
                  save: function ($event) {
                    return _vm.saveEditFilter()
                  },
                  cancel: function ($event) {
                    return _vm.cancelEditFilter()
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }